// Maps errors from /ai/llm_requests to a user-facing message. The backend
// rejects requests with `quota_exhausted: true` (403, same shape as the
// support bot's token limit) once the network's tixxtAI credit quota is
// exhausted — that case gets the localized unavailable-hint instead of a
// generic error.
export function aiRequestErrorMessage(err: unknown): string {
  const e = err as {
    message?: string;
    responseJson?: { quota_exhausted?: boolean; error?: string };
  };
  if (e?.responseJson?.quota_exhausted === true) {
    return I18n.t("js.composer.editor.ai.unavailable");
  }
  return (
    e?.message ||
    e?.responseJson?.error ||
    I18n.t("js.composer.editor.ai.request_error")
  );
}
